import Switch from 'react-switch';
import "./MySwitch.css";

type MySwitchProps = {
    id?: string;  // just for good looking code
    checked: boolean;
    disabled?: boolean;
    onChange: (checked: boolean) => void;
}

const HANDLE_DIAMETER = 12;
const SWITCH_WIDTH = 36;
const SWITCH_HEIGHT = 20;
const BOX_SHADOW = "0 0 2px 1px var(--container-border-color)";

export const MySwitch = ({ id, checked, disabled = false, onChange, ...rest } : MySwitchProps) => {

    return (
        <div 
            className="my-switch"
            data-testid={id}
        >
            <Switch
                {...rest}
                checked={checked}
                uncheckedIcon={false}
                checkedIcon={false}
                handleDiameter={HANDLE_DIAMETER}
                width={SWITCH_WIDTH}
                height={SWITCH_HEIGHT}
                boxShadow={BOX_SHADOW}
                onColor="#B0E0E6"
                onChange={onChange} 
                id={id}
                disabled={disabled}
            />
         </div>
    )
}